<template lang="pug">
.receive-packet-container
  .now-money-container
    Lottie.lottie(
      key="bcg_lottie",
      url="https://m.hellobike.com/resource/helloyun/08345/s2xRY_111.json"
    )
    .receive-packet-block
      .packet-bussiness
        img(v-if="couponInfo.propIcon" :src="couponInfo.propIcon")
        .packet-bussiness-text {{couponInfo.goodsPropDesc}}
      .packet-price(v-if="couponInfo.propType !== 26")
        .packet-price-num {{couponInfo.amount}}
        .packet-price-yuan(v-if="couponInfo.unit") {{couponInfo.unit}}
      .packet-award(v-else) {{couponInfo.amount}}
      .packet-no-threshold {{couponInfo.subtitle}}
      .packet-day-limit {{couponInfo.propEffectiveDays}}天有效期，请在有效期内使用
      .packet-receive-button(@click="goToUse") 收下去使用
    .receive-packet-close(@click.stop="closeModal")
      img.close(src="https://m.hellobike.com/resource/helloyun/08345/KyfI3xjHl3.png")
    .shadow
</template>

<script>
import Lottie from '@/components/lottie';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { desc, getName } from '../utils.js';

export default {
  components: {
    Lottie,
  },
  props: {
    couponInfo: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    UBT.moduleExpose({
      pageId: 'platform_openedcard_page',
      categoryId: 'platform',
      moduleId: 'platform_coupon_pop',
      contentId: 'platform_coupon_pop',
      exposureTimes: 1,
      businessInfo: {
        BusinessLine: this.couponInfo.propBusinessLine,
      },
    });
  },
  methods: {
    desc,
    getName,
    closeModal() {
      this.$emit('refresh');
      this.$emit('update:show', false);
    },
    async goShare() {
      this.$emit('goShare');
      this.closeModal();
    },
    goToUse() {
      this.$emit('goToUse', this.couponInfo);
      this.$emit('update:show', false);
    },

  },
};
</script>
<style lang="less" scoped>
.receive-packet-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 222;

  .lottie {
    z-index: 101;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }

  .now-money-container {
    margin-top: 2rem;

    .receive-packet-block {
      width: 100%;
      height: 3.64rem;
      background-image: url(https://m.hellobike.com/resource/helloyun/22042/FugMHekLpW.png);
      background-size: 100% 100%;
      margin: 0 auto;
      z-index: 101;
      position: relative;

      .packet-bussiness {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 0.74rem;

        img {
          width: 0.187rem;
          height: 0.187rem;
        }

        .packet-bussiness-text {
          // width: 0.28rem;
          height: 0.2rem;
          font-size: 0.14rem;
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-weight: 500;
          color: #531900;
          line-height: 0.2rem;
        }
      }

      .packet-price {
        margin-top: 0.25rem;
        display: flex;
        justify-content: center;
        align-items: flex-end;

        .packet-price-num {
          height: 0.74rem;
          font-size: 0.7rem;
          font-family: DINAlternate-Bold, DINAlternate, sans-serif;
          font-weight: bold;
          color: #fa4614;
          line-height: 0.74rem;
        }

        .packet-price-yuan {
          margin: 0 0 0.08rem 0.02rem;
          width: 0.22rem;
          height: 0.3rem;
          font-size: 0.22rem;
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-weight: 500;
          color: #fa4614;
          line-height: 0.3rem;
        }
      }

      .packet-award {
        margin: 0.25rem auto 0 auto;
        width: 0.69rem;
        height: 0.69rem;
        background-image: url(https://m.hellobike.com/resource/helloyun/08345/iBMsO8400i.png);
        background-size: 100% 100%;
        color: #7d3b2a;
        line-height: 0.69rem;
        text-align: center;
        margin-bottom: 0.1rem;
        font-size: 0.18rem;
      }

      .packet-no-threshold {
        margin: 0.01rem auto 0 auto;
        width: fit-content;
        height: 0.22rem;
        font-size: 0.16rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #b16652;
        line-height: 0.22rem;
      }

      .packet-day-limit {
        margin: 0.37rem auto 0 auto;
        margin-top: 0.37rem;
        width: fit-content;
        height: 0.17rem;
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #fff3d0;
        line-height: 0.17rem;
      }

      .packet-receive-button {
        text-align: center;
        margin: 0.1rem auto 0 auto;
        width: 1.5rem;
        height: 0.38rem;
        background: linear-gradient(90deg, #ffedd3 0%, #ffdcb4 100%);
        box-shadow: inset 0 0.01rem 0 0 rgba(255, 255, 255, 0.9);
        border-radius: 0.26rem;
        font-size: 0.16rem;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 600;
        color: #531900;
        line-height: 0.38rem;
      }
    }

    .receive-packet-close {
      display: flex;
      justify-content: center;
      z-index: 101;
      position: relative;

      .close {
        width: 0.3rem;
        height: 0.3rem;
        z-index: 101;
      }
    }
  }

  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 100;
  }
}
</style>
